import React from 'react';
import { Search } from 'lucide-react';
import { shouldShowCardsToolbarSearch } from '../../../shared/utils/listPageSearchVisibility';

/**
 * Toolbar search — visible in card view only when `viewMode` is passed.
 * Table view uses double-click column header filters instead.
 */
export default function QawaemTableToolbarSearch({
  value,
  onChange,
  placeholder = 'بحث…',
  viewMode,
}) {
  if (viewMode != null && !shouldShowCardsToolbarSearch(viewMode)) return null;

  return (
    <div className="relative w-[min(300px,42vw)] min-w-[200px] shrink-0">
      <Search className="absolute inset-y-0 start-3 my-auto h-4 w-4 text-console-subtle pointer-events-none" />
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full h-[38px] ps-10 pe-3 glass-input text-sm focus:outline-none focus:ring-2 focus:ring-[#6e9b6e]/40"
      />
    </div>
  );
}
